// O QUE O APP DIZ QUANDO ALGO DÁ ERRADO — sempre texto, sempre em português (dono, 2026-10-29:
// "app ultraprofissional"). Três buracos que este arquivo fecha:
//   1. o 422 do servidor chega com a frase do pydantic em INGLÊS ("Field required");
//   2. sem resposta, o axios diz "Network Error" / "Request failed with status code 500";
//   3. 184 avisos fazem `toast.error(e.response?.data?.detail || '...')` — quando o `detail` é
//      dicionário ou lista, o toast recebe um OBJETO e o React derruba a tela inteira
//      ("Objects are not valid as a React child"). `instalarAvisosEmTexto` converte na entrada do
//      toast, e por isso vale para todas as telas, inclusive as que ainda vão ser escritas.

import toast from 'react-hot-toast';

const FRASES = [
  [/^field required$/i, () => 'campo obrigatório'],
  [/^input should be a valid (string|text)/i, () => 'deve ser um texto'],
  [/^input should be a valid (number|integer|decimal)/i, () => 'deve ser um número'],
  [/^input should be a valid (date|datetime)/i, () => 'data inválida'],
  [/^input should be a valid boolean/i, () => 'deve ser sim ou não'],
  [/^input should be a valid (list|array)/i, () => 'deve ser uma lista'],
  [/^input should be a valid dictionary/i, () => 'formato inválido'],
  [/not a valid email/i, () => 'e-mail inválido'],
  [/^string should have at least (\d+) characters?/i, (m) => `deve ter pelo menos ${m[1]} caracteres`],
  [/^string should have at most (\d+) characters?/i, (m) => `deve ter no máximo ${m[1]} caracteres`],
  [/^input should be greater than or equal to (\S+)/i, (m) => `deve ser maior ou igual a ${m[1]}`],
  [/^input should be greater than (\S+)/i, (m) => `deve ser maior que ${m[1]}`],
  [/^input should be less than or equal to (\S+)/i, (m) => `deve ser menor ou igual a ${m[1]}`],
  [/^input should be less than (\S+)/i, (m) => `deve ser menor que ${m[1]}`],
  [/^input should be /i, () => 'valor não permitido'],
  [/^value error, (.+)$/i, (m) => m[1]],
  [/^assertion failed, (.+)$/i, (m) => m[1]],
];

export function traduzirFrase(msg) {
  const t = String(msg || '').trim();
  for (const [re, f] of FRASES) { const m = t.match(re); if (m) return f(m); }
  return t;
}

// O 422 do pydantic: `[{loc: ['body', 'cliente_nome'], msg: 'Field required'}, ...]`.
export function textoDaValidacao(lista) {
  const partes = (Array.isArray(lista) ? lista : []).slice(0, 3).map((e) => {
    const loc = (Array.isArray(e?.loc) ? e.loc : []).filter((x) => x !== 'body' && x !== 'query' && typeof x === 'string');
    const campo = loc.length ? loc[loc.length - 1].replace(/_/g, ' ') : '';
    const frase = traduzirFrase(e?.msg);
    return campo ? `${campo[0].toUpperCase()}${campo.slice(1)}: ${frase}` : frase;
  }).filter(Boolean);
  if (!partes.length) return 'Dados inválidos';
  const resto = lista.length - partes.length;
  return partes.join(' · ') + (resto > 0 ? ` (+${resto})` : '');
}

// Quando o servidor não explicou nada: o que dizer pelo código (ou pela falta de resposta).
export function textoPeloStatus(error) {
  const st = error?.response?.status;
  if (!error?.response) {
    if (error?.code === 'ECONNABORTED' || /timeout/i.test(String(error?.message || ''))) {
      return 'O servidor demorou para responder. Tente de novo.';
    }
    return 'Sem conexão com o servidor. Confira a internet e tente de novo.';
  }
  if (st === 401) return 'Sua sessão expirou. Entre novamente.';
  if (st === 403) return 'Você não tem permissão para esta ação.';
  if (st === 404) return 'Registro não encontrado — ele pode ter sido apagado.';
  if (st === 409) return 'Este registro mudou enquanto você editava. Recarregue e tente de novo.';
  if (st === 413) return 'Arquivo grande demais para enviar.';
  if (st === 422) return 'Dados inválidos.';
  if (st === 429) return 'Muitas tentativas seguidas. Aguarde um instante.';
  if (st >= 500) return `O servidor encontrou um erro (${st}). Tente de novo em instantes.`;
  return `Não foi possível concluir (erro ${st}).`;
}

const TECNICAS = /^(Network Error|Request failed with status code \d+|timeout of \d+ms exceeded|canceled)$/;

// QUALQUER COISA -> texto que se mostra. Aceita string, o `detail` em qualquer forma, Error do axios.
export function textoDoAviso(x) {
  if (x == null || typeof x === 'string' || typeof x === 'number') return x;
  if (typeof x === 'function' || (typeof x === 'object' && x.$$typeof)) return x;   // toast(c => <jsx/>)
  if (Array.isArray(x)) return textoDaValidacao(x);
  if (x.isAxiosError || x.response || x.request) {
    if (x.mensagem) return x.mensagem;
    const d = x.response?.data?.detail;
    if (d != null) return textoDoAviso(d);
    return textoPeloStatus(x);
  }
  if (x instanceof Error) return TECNICAS.test(x.message) ? textoPeloStatus(x) : (x.message || 'Erro inesperado');
  const m = x.msg || x.mensagem || x.message || x.detail || x.erro;
  if (m != null) return textoDoAviso(m);
  return 'Não foi possível concluir a ação.';
}

// O RASCUNHO QUE NÃO GRAVOU AVISA — Rhoana, card da Luzia, 2026-10-30: "botei o protocolo e data mas n fica salvo,
// ai qnd saio some". As etapas da Esteira gravavam o formulário com `catch { silencioso }`: um 422 recusou TODA
// gravação da Engenharia por um dia, e a tela seguia mostrando o digitado como se estivesse salvo. Um aviso só
// (id fixo — o protocolo grava a cada tecla), dizendo o que o servidor recusou e que o digitado NÃO está gravado.
// `aoGravar` recebe o que o SERVIDOR devolveu: é por ele que a caixa "Pendências para avançar" marca o item só
// depois de gravado — antes ela seguia dizendo "falta o protocolo" até alguém reabrir o card.
export const gravarRascunho = (promessa, aoGravar) => promessa.then((r) => { if (aoGravar && r?.data) aoGravar(r.data); }, (e) => {
  toast.error(`Não foi salvo — ${textoDoAviso(e)}. O que você digitou ainda não está gravado.`,
    { id: 'rascunho-nao-gravou', duration: 8000 });
});

/** Para `aoGravar` das etapas da Esteira: o card que o SERVIDOR devolveu (kit, histórico e fluxo frescos — o `card`
 *  da closure pode ser anterior a um `onUpdated` da mesma etapa, como o recarregar do 409 da Logística), mantendo do
 *  card aberto só o que a resposta de escrita não traz: o cliente lido do cadastro e o resumo da obra/proposta. */
const DO_CARD_ABERTO = ['resumo', 'cliente_nome', 'cliente_telefone', 'cliente_email', 'cliente_doc'];
export const comOFluxoGravado = (card, onUpdated) => (d) => {
  if (!onUpdated || !d?.fluxo) return;
  const manter = {}; DO_CARD_ABERTO.forEach((k) => { if (card && card[k] != null) manter[k] = card[k]; });
  onUpdated({ ...d, ...manter });
};

const METODOS = ['error', 'success', 'loading', 'custom'];
export function instalarAvisosEmTexto(toast) {
  if (!toast || toast.__emTexto) return toast;
  const base = toast;
  for (const k of METODOS) {
    const orig = base[k];
    if (typeof orig === 'function') base[k] = (msg, ...resto) => orig(textoDoAviso(msg), ...resto);
  }
  base.__emTexto = true;
  return base;
}
